module.exports = __webpack_public_path__ + "img/ai02.a768f256.png";